import createIcon from '../../createIcon';

/**
 * @component @name Spellcheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNzIwNSAxNS4yNUgxMy44MTA1TDguNzAwNDcgMi4yNUg2Ljg0MDQ3TDEuNzMwNDcgMTUuMjVIMy44MjA0N0w0Ljk0MDQ3IDEyLjI1SDEwLjU4MDVMMTEuNzIwNSAxNS4yNVpNNS43MDA0NyAxMC4yNUw3Ljc3MDQ3IDQuNzNMOS44NDA0NyAxMC4yNUg1LjcwMDQ3Wk0yMC44NjA1IDEwLjg0TDEyLjc3MDUgMTguOTNMOS4xMDA0NyAxNS4yNUw3LjY5MDQ3IDE2LjY2TDEyLjc4MDUgMjEuNzVMMjIuMjcwNSAxMi4yNUwyMC44NjA1IDEwLjg0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Spellcheck = createIcon('Spellcheck', [
  [
    'path',
    {
      d: 'M11.7205 15.25H13.8105L8.70047 2.25H6.84047L1.73047 15.25H3.82047L4.94047 12.25H10.5805L11.7205 15.25ZM5.70047 10.25L7.77047 4.73L9.84047 10.25H5.70047ZM20.8605 10.84L12.7705 18.93L9.10047 15.25L7.69047 16.66L12.7805 21.75L22.2705 12.25L20.8605 10.84Z',
      key: '66mk64',
    },
  ],
]);

export default Spellcheck;
